import React from "react";
import { Button } from "@mui/material";
import PlayCircleOutlineRoundedIcon from "@mui/icons-material/PlayCircleOutlineRounded";
import { BRAND_BLUE } from "../../theme/colors";

function tutorialUrl(value) {
  try {
    const url = new URL(value);
    return url.protocol === "https:" && !url.username && !url.password ? url.href : undefined;
  } catch {
    return undefined;
  }
}

export default function NotificationVideo({ notification }) {
  const url = tutorialUrl(notification.video_url);
  if (!url) return null;
  const label = notification.video_cta_text?.trim() || "Watch Tutorial";
  const title = notification.video_title || notification.title || "Tutorial";

  return (
    <Button
      component="a"
      href={url}
      target="_blank"
      rel="noopener noreferrer"
      size="small"
      startIcon={<PlayCircleOutlineRoundedIcon />}
      aria-label={`${label}: ${title} (opens in a new tab)`}
      onClick={(event) => event.stopPropagation()}
      sx={{ color: BRAND_BLUE, fontWeight: 700, textTransform: "none" }}
    >
      {label}
    </Button>
  );
}
